import { NotFoundContainer } from "components/notFoundContainer"

export const ErrorPage = () => {

    return (
        <NotFoundContainer></NotFoundContainer>
    )
}